interface InstallHelpIosProps {
  onClose: () => void;
}

/**
 * Tutorial visual de instalação no iOS/Safari. O iOS nunca dispara
 * `beforeinstallprompt`, então o caminho é manual: Compartilhar →
 * Adicionar à Tela de Início. Reaproveitado pelo card flutuante
 * (`InstallPrompt`) e pelo hero embutido na home (`ModuleHome`).
 */
export function InstallHelpIos({ onClose }: InstallHelpIosProps) {
  return (
    <div
      className="install-help"
      role="dialog"
      aria-modal="true"
      aria-labelledby="install-help-title"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="install-help__panel">
        <header className="install-help__head">
          <span className="install-help__eyebrow">iOS · Safari</span>
          <strong id="install-help-title" className="install-help__title">
            Como adicionar à tela de início
          </strong>
          <button
            type="button"
            className="install-help__close"
            onClick={onClose}
            aria-label="Fechar tutorial"
          >
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M6 6l12 12" />
              <path d="M18 6l-12 12" />
            </svg>
          </button>
        </header>
        <ol className="install-help__steps">
          <li>
            <span className="install-help__step-num">1</span>
            <div>
              Toque no botão <strong>Compartilhar</strong>{" "}
              <span aria-hidden="true" className="install-help__inline-icon">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 16V4" />
                  <path d="M8 8l4-4 4 4" />
                  <path d="M5 14v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5" />
                </svg>
              </span>{" "}
              na barra inferior do Safari.
            </div>
          </li>
          <li>
            <span className="install-help__step-num">2</span>
            <div>
              Role e toque em{" "}
              <strong>Adicionar à Tela de Início</strong>{" "}
              <span aria-hidden="true" className="install-help__inline-icon">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="4" y="4" width="16" height="16" rx="3" />
                  <path d="M12 8v8" />
                  <path d="M8 12h8" />
                </svg>
              </span>
              .
            </div>
          </li>
          <li>
            <span className="install-help__step-num">3</span>
            <div>
              Confirme o nome (<em>Virtus Intensiva</em>) e toque em{" "}
              <strong>Adicionar</strong>.
            </div>
          </li>
        </ol>
        <p className="install-help__note">
          Ao abrir pelo ícone na tela de início, o app vai em tela cheia, sem
          a barra do navegador — e funciona offline depois da primeira carga.
        </p>
      </div>
    </div>
  );
}
